// These values are copies of IDs used in SHR_Lookup where LookupType is one of QTEType, QTECode, QTESubcode

export enum QTEType {
  Material = 1100,
  Edge = 1102,
  Radius = 1104,
  Diagonal = 1105,
  Sink = 1106,
  Cutout = 1107,
  Labor = 1108,
  RadiusLaminate = 1109,
  MiteredEdge = 1110,
  Other = 1111,
}

export enum QTECode {
  NONE = -1, // an invalid code, matching nothing explicitly for dead-end-rules
  BN = 1201, //bullnose edge
  DBLRad = 1202, //double radius edge
  Eased = 1203, //eased edge
  HalfBN = 1204, //half bullnose edge
  Ogee = 1205, //ogee edge
  PCutOut = 1206, //unknown
  SglBvl = 1207, //singl Bevel edge (???)
  Upgrd = 1208, // Upgrade edge (maybe custom???)
  R1 = 1209, //Radius 1-6"
  R2 = 1210, //Radius >6-18"
  R3 = 1211, //Radius >18-30"
  R4 = 1212, //Radius >30-42"
  R5 = 1213, //Radius >42"
  ND = 1214,
  Wtrfll = 1215, // Waterfall _edge_ (not waterfal panel)
  Square = 1216, // square edge
  TghtRad = 1217, // tight radius?
  FllWrpTghtRad = 1218, //unknown
  FllWrpOgee = 1219, //unknown
  Standard = 1220, //unknown
  Crscnt = 1221, //unknown
  Unpolished = 1230, // Unpolished cutout for sinks or cooktops
  PolishedOther = 1231, // Polished cutout for non-special sink (below is the special ones)
  PolishedCastIron = 1232, // Polished cutout for Cast Iron sinks
  PolishedApron = 1233, // Polished cutout for Apron sinks
  PolishedIntegratedSolidSurface = 1234, // polished cutout for integrated solid surface sinks
  PolishedVanity = 1235, // polished cutout for integrated solid surface sinks
  Warranty = 1240, // warranties (can only select one of these)
  CustomLabor = 1241, //Customer Labor (this gets a note)
  InsideCorner = 1242, //Inside Diagonal Corner
  OutsideCorner = 1243, //Outside Diagonal Corner
  OversizeFee = 1244, //Oversize Product Fees
  DishwasherMount = 1245, //Dishwasher mount
  ChipMinimizer = 1246, //Chip Minimizer
  Mileage = 1247, // Mileage
  RoundOver = 1248, // Edge Round Over
  EndCap = 1249, // laminate only
  EndSplash = 1250, // laminate only
  SmallProjectFee = 1251, // Small Project Fee (should be only in Other)
}

// These are additional modifiers for the above QTECodes
export enum QTESubCode {
  CM2 = 1302, //2CM
  CM3 = 1303, //3CM
  CM4 = 1304, //4CM
}
